import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

import { SuggestCategoriesTileComponent } from 'ish-shared/components/search/suggest-categories-tile/suggest-categories-tile.component';

@Component({
  selector: 'ish-suggest-categories',
  imports: [CommonModule, TranslatePipe, SuggestCategoriesTileComponent],
  templateUrl: './suggest-categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestCategoriesComponent {
  readonly categories = input.required<string[]>();
  readonly maxAutoSuggests = input<number>(undefined);
  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly routeChange = output<void>();

  handleInputFocus(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.routeChange.emit();
  }
}
